import { jsx as _jsx } from "react/jsx-runtime";
import React, { forwardRef } from 'react';
import { getDataTestId } from '../utils/helpers';
export const FileUploadInput = forwardRef(({ acceptTypesString, disabled, dataTestId, id, ariaInvalid, ariaDescribedBy, onChange }, ref) => {
    return (_jsx("input", { type: 'file', ref: ref, accept: acceptTypesString, onChange: onChange, style: { display: 'none' }, disabled: disabled, "data-testid": getDataTestId(dataTestId, 'input'), id: id, "aria-invalid": ariaInvalid || undefined, "aria-describedby": ariaDescribedBy }));
});
FileUploadInput.displayName = 'FileUploadInput';
